import { getIconForProfileGroup } from 'cadenza/map/routing/routing-sidebar/profile/routing-profile-service';
import { icon } from 'cadenza/utils/icon/icon';
import './layer-legend-route-summary.css';
import {
  SPATIAL_ISOCHRONE_TYPE,
  TEMPORAL_ISOCHRONE_TYPE
} from 'cadenza/map/routing/routing-sidebar/routing-modes/isochrones/calculation-options/calculation-options-validator';
import { ROUTE_ATTRIBUTES_ICONS } from 'cadenza/map/routing/routing-sidebar/route/route-utils';
import './layer-legend-isochrone-summary.css';

const NAME = 'd-layer-legend-isochrone-summary';

export class LayerLegendIsochroneSummary extends HTMLElement {

  #isochroneSummary;

  /**
   * Component's constructor
   *
   * @param {object} isochroneSummary - Isochrone summary
   * @param {string} isochroneSummary.routingProfileGroup - Routing profile group of the isochrone
   * @param {number} isochroneSummary.isochroneType - Either SPATIAL or TEMPORAL
   * @param {number} isochroneSummary.value - Maximum value either in meter or seconds depending on isochroneType
   */
  constructor (isochroneSummary) {
    super();
    this.#isochroneSummary = isochroneSummary;
  }

  connectedCallback () {
    this.classList.add(NAME);
    this._renderContent();
  }

  cloneNode () {
    const clone = new LayerLegendIsochroneSummary(this.#isochroneSummary);
    if (this.parentElement) {
      clone.connectedCallback();
    }
    return clone;
  }

  _renderContent () {
    const profileIcon = getIconForProfileGroup(this.#isochroneSummary.routingProfileGroup);
    const typeIcon = getIconForIsochroneType(this.#isochroneSummary.isochroneType);
    this.innerHTML = '';

    this.append(
      profileIcon, typeIcon
    );
  }

}

customElements.define(NAME, LayerLegendIsochroneSummary);

const ICONS_BY_ISOCHRONE_TYPE = {
  [TEMPORAL_ISOCHRONE_TYPE]: ROUTE_ATTRIBUTES_ICONS.duration,
  [SPATIAL_ISOCHRONE_TYPE]: ROUTE_ATTRIBUTES_ICONS.distance
};

function getIconForIsochroneType (type) {
  return icon(ICONS_BY_ISOCHRONE_TYPE[type]);
}
